'use client';
import React, { useEffect, useState } from 'react';
import { FontIcon } from '../FontIcon';
import styles from './like.module.sass';
import cn from 'classnames';

interface LikeDislikeProps extends React.HTMLAttributes<HTMLDivElement> {
    likeLabel?: string;
    dislikeLabel?: string;
    onActionClick: (action: 'like' | 'dislike') => void; // Renamed prop to avoid conflict
    isContentLiked: 'like' | 'dislike' | null;
}

export const LikeDislike = ({
    likeLabel,
    dislikeLabel,
    onActionClick,
    className,
    isContentLiked,
    ...props
}: LikeDislikeProps) => {
    const [activeButton, setActiveButton] = useState<'like' | 'dislike' | null>(isContentLiked);

    useEffect(() => {
        setActiveButton(isContentLiked);
    }, [isContentLiked]);

    const handleClick = (action: 'like' | 'dislike') => {
        setActiveButton(action === activeButton ? null : action); // Toggle the active state
        onActionClick(action); // Call the renamed prop function with the action
    };

    return (
        <div className={cn(className, styles.likes)} {...props}>
            <div className={styles.item} onClick={() => handleClick('like')}>
                <span className={styles.ico} data-test-id="like-button">
                    {activeButton === 'like' ? (
                        <FontIcon name="like-filled" color="orange" />
                    ) : (
                        <FontIcon name="like" />
                    )}
                </span>
                {likeLabel && <span>{likeLabel}</span>}
            </div>
            <div className={styles.item} onClick={() => handleClick('dislike')}>
                <span className={styles.ico} data-test-id="dislike-button">
                    {activeButton === 'dislike' ? (
                        <FontIcon name="dislike-filled" color="orange" />
                    ) : (
                        <FontIcon name="dislike" />
                    )}
                </span>
                {dislikeLabel && <span>{dislikeLabel}</span>}
            </div>
        </div>
    );
};
